import { SignUp } from "@clerk/clerk-react";
import { GeoKerjaLogo } from "@/components/GeoKerjaLogo";

/**
 * Invitation acceptance page. Clerk passes the invitation ticket via the
 * URL fragment; the `<SignUp />` component reads it automatically and
 * walks the user through setting a password and (optionally) MFA.
 *
 * Every invitation lands here — administrators' and employees' alike — so the
 * welcome names no role; it used to tell employees they had been invited as
 * an administrator (BUG-2026-018).
 *
 * After completion, Clerk redirects back to `/` and the protected-route
 * guard takes over from there: an admin reaches the dashboard, an employee
 * their own portal.
 */
const InviteAccept = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6">
      <div className="mb-8">
        <GeoKerjaLogo />
      </div>
      <div className="w-full max-w-md">
        <h1 className="mb-1 text-center text-2xl font-semibold">Welcome to GeoKerja</h1>
        <p className="mb-6 text-center text-sm text-muted-foreground">
          Your organisation has invited you to GeoKerja. Set up your account below.
        </p>
        <SignUp
          path="/invite-accept"
          routing="path"
          fallbackRedirectUrl="/"
          appearance={{
            elements: {
              rootBox: "w-full",
              card: "shadow-lg border border-border",
            },
          }}
        />
      </div>
    </div>
  );
};

export default InviteAccept;
